import { ApiModule } from '@common/index';
import { type EducationProgressElementItem, type EducationProgressItem } from '../../education/models';

export class EducationProgressApi extends ApiModule {
  protected endpoint = '/post-graduate-education-template';

  public loadProgress(educationId: number) {
    return this.api.get<EducationProgressItem>(`${this.endpoint}/load-progress?educationId=${educationId}`);
  }

  public getElementProgress(educationId: number) {
    return this.api.get<EducationProgressElementItem[]>(`${this.endpoint}/list-progress-elements?educationId=${educationId}`);
  }
}
